import { callApi } from './api';

import { School } from '@/types/school';

export const updateSchool = async (schoolID: number, requestBody: School) => {
  const { status, result } = await callApi<School>(
    `schools/${schoolID}`,
    'PUT',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
